export default __webpack_public_path__ + "static/media/m_engineering_card07_1.13ea5fae.png";